import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Cookie } from 'ng2-cookies';

@Injectable()
export class Configuration {
  public header = new HttpHeaders({
    'Content-Type': 'application/json',
    lan: 'en',
    authorization: this.getItem('token') || ''
  });
  token = this.getItem('token') || '';

  constructor() {}

  setItem(res, item, val) {
    Cookie.set('token', val, 1, '/');
    Cookie.set('mqtt', res.data.mqttTopic, 1, '/');
    Cookie.set(item, val, 1, '/');
    this.header = new HttpHeaders({
      'Content-Type': 'application/json',
      lan: 'en',
      authorization: val || ''
    });
  }

  getItem(item) {
    return Cookie.get(item);
  }

  removeItem(item) {
    Cookie.delete(item, '/');
  }

  clear() {
    Cookie.deleteAll('/');
  }
}
